import { Component, OnInit, inject } from '@angular/core';
// import { environment } from '../../../../environments/environment';
import { SessionStorageService }  from '../../../services/session-storage.service'
import { EnvironmentService } from '../../../services/environment.service';

@Component({
    selector: 'app-uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    standalone: false
})
export class UploaderComponent implements OnInit {
  private ss = inject(SessionStorageService);
  private envSvc = inject(EnvironmentService);

  private environment;
  externalUrl;
  session: string = this.ss.get('session');

  ngOnInit() {
    this.environment = this.envSvc.get();

    const parser = document.createElement('a');
    parser.href = this.environment.apiBase;
    this.externalUrl = `${parser.protocol}//${parser.hostname}/cetera/rbm.aspx#upload-page`;
  }
}
